import React from 'react';

export const UnavailableBannerContext = React.createContext(() => null);
